import { useMutation } from '@tanstack/react-query'
import { useApiClient } from '@/shared/api'

export type ChatGrouping = 'integration' | 'agent'

export interface ChatReportGroupRow {
  groupKey: string
  generalMetrics: Record<string, number>
  dispositionMetrics: Record<string, number>
  durationMetrics: Record<string, number>
  latencyMetrics: Record<string, number>
}

export interface ChatReportResponse {
  grouping: ChatGrouping
  startDateStr: string
  endDateStr: string
  agentNames?: Record<string, string>
  data: ChatReportGroupRow[]
}

export interface ChatReportArgs {
  campaignId: number
  startDate: string
  endDate: string
  grouping: ChatGrouping
}

export function useGenerateChatReport() {
  const apiClient = useApiClient()
  return useMutation({
    mutationFn: async (args: ChatReportArgs) => {
      const params = new URLSearchParams({
        campaign_id: String(args.campaignId),
        start_date: args.startDate,
        end_date: args.endDate,
        grouping: args.grouping,
      })
      return apiClient<ChatReportResponse>(`/reports-chat?${params}`)
    },
  })
}
